import service from '@/services/SIRgpd_resul_rep';

export default {
  namespaced: true,

  actions: {
    /**
     * Permite obtener los parámetros de un WebApp Vue.
     */
    read({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRgpd_resul_rep: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRgpd_resul_rep: [
              {
                picdoc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                picter_nit: rootGetters['SICUDgpd_est_crd/state'].nit,
                piitas_val: event?.stepCreditInfo.crd_tas || 1.88,
                piival_pres: event.stepCreditInfo.crd_val,
                piicrd_pla: event.selectedInstallments,
                piicuo_ini: event.stepCreditInfo.crd_cuo_ini,
                piiporc_desc: event.stepCreditInfo.crd_por_des,
                piivr_descu: event.stepCreditInfo.crd_desc,
                piiaccesorio: event.stepCreditInfo.crd_acce,
                piivr_soat: event.stepCreditInfo.crd_soat,
                piivr_matri: event.stepCreditInfo.crd_mat,
                piivr_papel: event.stepCreditInfo.crd_pap,
                piipor_fondo: event.stepCreditInfo.crd_por_admon,
                // piivr_gasto: event.piivr_gasto,
              },
            ],
            eefeature: [
              {
                piope: '',
                picam: '',
                piregini: 1,
                pinumreg: 15,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRgpd_resul_rep;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              resolve(data.eegpd_resul_rep[0]);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
